import React from "react";
import * as Icon from "react-bootstrap-icons";

const EventDateItem = ({
  day = "Dayname",
  time_one = "timeone",
  time_two = "timetwo",
}) => {
  return (
    <div className="col-lg-6 col-md-6 col-sm-12 col-sm-12 date-wrapper">
      <div className="mycard">
        <div className="left">{day}</div>
        <div className="right">
          <div className="time-wrapper">
            <Icon.Clock /> {time_one}
          </div>
          <div className="time-wrapper">
            <Icon.Clock /> {time_two}
          </div>
        </div>
      </div>
    </div>
  );
};

export default EventDateItem;
